import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

const _toastError = toast.error;
toast.error = (m, o) => _toastError(m, typeof m === "string" && m.includes("hanya lihat") ? { ...o, id: "view-only" } : o);

api.interceptors.response.use((r) => r, (e) => {
  const d = e.response?.data?.detail;
  if (e.response?.status === 403 && typeof d === "string" && d.includes("hanya lihat")) toast.error(d, { id: "view-only" });
  return Promise.reject(e);
});

export const formatIDR = (n) =>
  "Rp " + Math.round(n || 0).toLocaleString("id-ID");

// modules each role can access (mirror of backend DEFAULT_ROLES)
export const ROLE_MODULES = {
  owner: ["dashboard","crm","quotations","projects","workorders","production","stock","purchasing","hr","attendance","payroll","finance","booking","machines","settings","audit","workflow","catalog"],
  sales: ["dashboard","crm","quotations","projects","booking","delivery","catalog"],
  designer: ["dashboard","workorders","production","projects","delivery"],
  operator: ["dashboard","workorders","production","machines","delivery"],
  kepala_data: ["dashboard","workorders","production","machines"],
  teknisi: ["dashboard","production","machines"],
  finishing: ["dashboard","workorders","production"],
  purchasing: ["dashboard","stock","purchasing"],
  finance: ["dashboard","finance","payroll","quotations"],
  hr: ["dashboard","hr","attendance","payroll"],
  staff: ["dashboard","attendance"],
};

export const hasRole = (user, ...roles) => (user?.roles || [user?.role]).some((r) => roles.includes(r));

export const can = (user, module) => {
  if (!user) return false;
  if (user.role === "owner") return true;
  if (Array.isArray(user.modules)) return user.modules.includes(module);
  return (ROLE_MODULES[user.role] || []).includes(module);
};
